module.exports = __webpack_public_path__ + "static/media/7-Thuiskok-fotoCaroline.1c01916f.jpg";